export const ERROR = 'error'

export const globalErrors = {
  en: {
    translation: {
      [ERROR]: {
        'http.401': 'Un Authorized',
      },
    },
  },
  es: {
    translation: {
      [ERROR]: {
        'http.401': 'No autorizado',
      },
    },
  },
}
